import React from "react";
import { Route, RouteProps, Redirect } from "react-router-dom";
import styled from "styled-components";
import Nav, { NAV_HEIGHT } from "./components/Nav";
import FlashMessage from "./components/FlashMessage";
import { apiClient } from "./App";

const StyledPrivateRoute = styled.div`
  display: flex;
  justify-content: stretch;

  main {
    padding-top: ${NAV_HEIGHT}px;
    flex: 1;
    height: 100vh;
    overflow-y: hidden;
    overflow-x: auto;
  }
`;

interface Props extends RouteProps {
  component: any;
}

class PrivateRoute extends React.Component<Props> {
  render() {
    const { component: Component, ...rest } = this.props;

    if (!apiClient.token) {
      return <Redirect to="/" />;
    }
    return (
      <>
        <Route
          {...rest}
          render={props => (
            <StyledPrivateRoute>
              <Nav />
              <main>
                <Component {...props} />
              </main>
              <FlashMessage />
            </StyledPrivateRoute>
          )}
        />
      </>
    );
  }
}

export default PrivateRoute;
